import React, { Component, createRef } from "react";
import InventoryServices from "../../services/axioServices/apiServices/InventoryServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import moment from "moment";
import * as XLSX from "xlsx";
import DespatchServices from "../../services/axioServices/apiServices/DespatchServices.js";
import { FinancealYearStartDateEndDate } from "../../utils/FinancialYearStartDateEndDate.js";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";
import { printFunction } from "../../components/print/printTemplate.js";

class StockStatementReport extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.despatchServices = new DespatchServices();
        this.state = {
            companyName: '',
            isGridView: true,
            tableStatus: "",
            stockStatementReportList: [],
            stockStatementByProductIdList: [],
            batchWisestockStatementReportList: [],
            totalProduceedQty: 0,
            totalIssuedQty: 0,
            closingBalance: 0,
            filterDetails: {
                startDate: "",
                endDate: "",
                search: "stock",
                totalAmount: "",
                with0BatchStock: false,
            },
            itemName: "",
            totalCount: "",
            stockTotalAmount: "",
            searchList: [
                { search: "Stock", value: "stock" },
                { search: "Batch Wise Stock", value: "BatchWiseStock" },
            ],
            validationRules: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "start date"
                        ),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "end date"
                        ),
                    },
                ],

            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        let dates = FinancealYearStartDateEndDate()
        let filterDetails = this.state.filterDetails
        filterDetails.startDate = dates.startDate
        filterDetails.endDate = dates.endDate
        this.setState({ filterDetails: filterDetails })
        const company = getAuthProps()
        this.setState({ companyName: company?.companyName })
    }

    getAllStockStatementReport = () => {
        let isAllFieldsValidate = this.isAllFieldsValidate();
        if (isAllFieldsValidate) {
            this.setState({ tableStatus: "Loading..." }, () => {
                let request = this.state.filterDetails
                this.despatchServices.getAllStockStatementReport(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        let totalCount = response.responseData.length
                        if (response.responseData.length === 0) {
                            this.setState({ tableStatus: "No Record Found" })
                        } else {
                            this.setState({ tableStatus: "" })
                        }
                        this.setState({ stockStatementReportList: response.responseData, totalCount: totalCount })
                    } else {
                        this.setState({ tableStatus: "" })
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        }
    }

    getAllBatchWiseStockStatementReport = () => {
        let isAllFieldsValidate = this.isAllFieldsValidate();
        if (isAllFieldsValidate) {
            this.setState({ tableStatus: "Loading..." }, () => {
                let request = this.state.filterDetails
                this.despatchServices.getAllBatchWiseStockStatementReport(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        let check = this.state.filterDetails.with0BatchStock
                        let res = response.responseData
                        if (check === false) {
                            res = res.filter(x => x.quantity > 0)
                        }
                        let totalCount = response.responseData.length
                        if (response.responseData.length === 0) {
                            this.setState({ tableStatus: "No Record Found" })
                        } else {
                            this.setState({ tableStatus: "" })
                        }
                        this.setState({ batchWisestockStatementReportList: res, totalCount: totalCount })
                    } else {
                        this.setState({ tableStatus: "" })
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        }
    }

    isAllFieldsValidate = () => {
        const newValidState = isValidForm(
            this.state.filterDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    openGridView = () => {
        this.setState({ isGridView: true });
    };


    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let filterDetails = this.state.filterDetails
        filterDetails.startDate = ""
        filterDetails.endDate = ""
        filterDetails.search = "stock"
        filterDetails.totalAmount = ""
        filterDetails.with0BatchStock = ""
        this.setState({
            filterDetails: filterDetails, validState: validState, stockTotalAmount: "0", itemsForStockLedgerList: [],
            stockStatementReportList: [], batchWisestockStatementReportList: [], noItemFound: "", totalCount: 0
        })
    }
    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value;
        this.setState({ filterDetails: details })

    };

    handleDropdownChange = (e, name) => {
        const value = e.target.value;
        let details = this.state.filterDetails;
        details[name] = value;
        this.setState({ filterDetails: details, tableStatus: "" });
    };
    handleCheckbox = (e, name) => {
        let details = this.state.filterDetails;
        details[name] = !details.with0BatchStock;
        this.setState({ filterDetails: details }, () => {
            this.getAllBatchWiseStockStatementReport()
        });
    };

    getALLStockStatementByProductId = (id, batchClearingEntryId, itemName) => {
        let request = [id, batchClearingEntryId]
        this.despatchServices.getALLStockStatementByProductId(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {

                const totalProduceedQty = response.responseData.reduce((sum, item) => sum + item.produceedQty, 0);
                const totalIssuedQty = response.responseData.reduce((sum, item) => sum + item.issuedQty, 0);
                const closingBalance = totalProduceedQty - totalIssuedQty;

                this.setState({ stockStatementByProductIdList: response.responseData, totalProduceedQty: totalProduceedQty, totalIssuedQty: totalIssuedQty, closingBalance: closingBalance }, () => {
                    this.setState({ isGridView: false, itemName: itemName })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getReportData = () => {
        if (this.state.filterDetails.search === 'stock') {
            this.getAllStockStatementReport()
        } else {
            this.getAllBatchWiseStockStatementReport()
        }
    }


    render() {
        return (
            <div className='stockSatementReport-page'>
                {/* Fisrt page  */}
                {this.state.isGridView === true ? (
                    <>
                        <div className="item-search !mb-3">
                            <div className="item-inner-grp flex gap-2.5 mb-3">
                                <div className="input-grp w-full" >
                                    <label>Start Date</label>
                                    <input
                                        className={`inputFocus ${this.state.validState?.error?.startDate ? "errorInput" : ""}`}
                                        type="date"
                                        id="startDate"
                                        name="startDate"
                                        autoComplete="off"
                                        value={this.state.filterDetails.startDate}
                                        onChange={(event) =>
                                            this.handleChange(event, "startDate")
                                        }

                                    />
                                    {/* <ValidationText
                                        error={this.state.validState.error.startDate}
                                    /> */}
                                </div>
                                <div className="input-grp w-full">
                                    <label>Ending Date</label>
                                    <input
                                        className={`inputFocus ${this.state.validState?.error?.endDate ? "errorInput" : ""}`}
                                        type="date"
                                        id="endDate"
                                        name="endDate"
                                        autoComplete="off"
                                        value={this.state.filterDetails.endDate}
                                        onChange={(event) => this.handleChange(event, "endDate")}
                                        style={{ width: "100%" }}
                                    />
                                    {/* <ValidationText
                                        error={this.state.validState.error.endDate}
                                    /> */}
                                </div>
                                <div className="search-grp w-full">
                                    <label>Search</label>
                                    <select
                                        name="search"
                                        className="w-full"
                                        value={this.state.filterDetails.search}
                                        onChange={(event) =>
                                            this.handleDropdownChange(
                                                event,
                                                "search",
                                                "filterDetails"
                                            )
                                        }
                                    >

                                        {this.state.searchList.map((x, key) => (
                                            <option key={key} value={x.value}>
                                                {x.search}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {this.state.filterDetails.search === 'BatchWiseStock' ?
                                    <div className="start-date w-full">
                                        <label>Total Amount</label>
                                        <input
                                            className="w-full"
                                            type="number"
                                            id="totalAmount"
                                            name="totalAmount"
                                            autocomplete="off"
                                            disabled
                                            value={this.state.stockTotalAmount
                                                ? this.state.stockTotalAmount
                                                : 0}
                                        />
                                    </div>
                                    : null}
                            </div>
                            {this.state.filterDetails.search !== 'stock' ?
                                <div className="input-grp flex items-center">
                                    <input
                                        className="inputFocus mr-[8px] !w-[18px] h-[18px]"
                                        type="checkbox"
                                        name="with0BatchStock"
                                        id="with0BatchStock"
                                        autocomplete="off"
                                        value={this.state.filterDetails.with0BatchStock}
                                        checked={this.state.filterDetails.with0BatchStock}
                                        onChange={(event) =>
                                            this.handleCheckbox(event, "with0BatchStock")
                                        }
                                    />
                                    <label className="!mb-0">With 0 Stock Batch</label>
                                </div>
                                : null}

                            <div className="btn-grp mt-3 ">
                                <button
                                    class="add-btn"
                                    onClick={() => this.getReportData()}
                                >
                                    Search
                                </button>
                                <button className="cancel-btn" onClick={() => this.resetForm()} >Cancel</button>

                                {this.state.totalCount > 0 ?
                                    <button
                                        class="print-btn"
                                        onClick={() => printFunction()}
                                    >
                                        Print
                                    </button>
                                    : null}

                            </div>
                        </div>
                        <div className="table-upper">
                            <p className="mb-[3px] text-[15px] font-medium text-[#474747]" >
                                Total Count :- {this.state.totalCount ? this.state.totalCount : 0}
                            </p>
                        </div>
                        {this.state.filterDetails.search === "stock" ? (
                            <div class="item-listing">
                                <div className="hidden print-title">
                                    <h4 className="text-black font-semibold text-[18px]">Stock Statement</h4>
                                    <p className="text-black"><span>Start date:- {moment(this.state.filterDetails.startDate).format('DD-MM-YYYY')}</span>, <span>End date:- {moment(this.state.filterDetails.endDate).format('DD-MM-YYYY')}</span></p>
                                </div>
                                <div class="itemList-table">
                                    <div class="table-container" style={{ height: "calc(100vh - 200px)" }} >
                                        <table class="itemList">
                                            <>

                                                <thead>
                                                    <tr>
                                                        <td style={{ width: "60%" }} className="w-[60%] print-w-60">Item Name</td>
                                                        <td style={{ width: "20%" }} className="w-[20%] print-w-20">Mrp</td>
                                                        {/* <td style={{ width: "20%" }}>Batch No</td> */}
                                                        <td style={{ width: "20%" }} className="w-[20%] print-w-20">Stock</td>
                                                    </tr>
                                                </thead>


                                                <tbody>
                                                    {this.state.stockStatementReportList && this.state.stockStatementReportList.length > 0 ? (
                                                        this.state.stockStatementReportList.map((details, key) => (
                                                            <tr
                                                                key={key}
                                                                className="hover:bg-gray-200 cursor-pointer "
                                                                onClick={() => this.getALLStockStatementByProductId(details.productId, details.batchClearingEntryId, details.itemName)}
                                                            >
                                                                <td>{details.itemName}</td>
                                                                <td>{details.mrp}</td>
                                                                {/* <td>{details.batchNo}</td> */}
                                                                <td>{details.totalQty}</td>
                                                            </tr>
                                                        ))
                                                    ) : this.state.stockStatementReportList && this.state.stockStatementReportList.length === 0 && this.state.tableStatus !== "" ? (
                                                        <tr>
                                                            <td colSpan={4} style={{ textAlign: "center", fontSize: "16px" }}>
                                                                {this.state.tableStatus}
                                                            </td>
                                                        </tr>
                                                    ) : this.state.stockStatementReportList && this.state.stockStatementReportList.length === 0 && this.state.tableStatus === "" ? null : ""}
                                                </tbody>

                                            </>
                                        </table>
                                    </div>
                                </div>
                            </div>) :
                            (
                                <div class="item-listing print:w-full" ref={this.printRef} id="printableArea">
                                    <div class="itemList-table">
                                        <div class="table-container" style={{ height: "calc(100vh - 235px)" }} >
                                            <table class="itemList">
                                                <>

                                                    <thead>
                                                        <tr>
                                                            <td style={{ width: "20%" }}>Item Name</td>
                                                            <td style={{ width: "10%" }}>Batch No.</td>
                                                            <td style={{ width: "10%" }}>Mfg. Date</td>
                                                            <td style={{ width: "10%" }}>Exp. Date</td>
                                                            <td style={{ width: "10%" }}>MRP</td>
                                                            <td style={{ width: "10%" }}>Stock</td>
                                                            {/* <td style={{ width: "10%" }}>Rate</td>
                                                        <td style={{ width: "10%" }}>Amount</td> */}
                                                        </tr>
                                                    </thead>


                                                    <tbody>
                                                        {this.state.batchWisestockStatementReportList && this.state.batchWisestockStatementReportList.length > 0 ? (
                                                            this.state.batchWisestockStatementReportList.map((details, key) => (
                                                                <tr
                                                                    key={key}

                                                                >
                                                                    <td>{details.productId.ItemName}</td>
                                                                    <td>{details.batchNo}</td>
                                                                    <td>{moment(details.mfgDate).format('DD MMM YYYY')}</td>
                                                                    <td>{moment(details.expDate).format('DD MMM YYYY')}</td>
                                                                    <td>{details.mrp}</td>
                                                                    <td>{details.quantity}</td>
                                                                    {/* <td>{details.rate}</td>
                                                                <td>{details.amount}</td> */}
                                                                </tr>
                                                            ))
                                                        ) : this.state.batchWisestockStatementReportList && this.state.batchWisestockStatementReportList.length === 0 && this.state.tableStatus !== "" ? (
                                                            <tr>
                                                                <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                                                                    {this.state.tableStatus}
                                                                </td>
                                                            </tr>
                                                        ) : this.state.batchWisestockStatementReportList && this.state.batchWisestockStatementReportList.length === 0 && this.state.tableStatus === "" ? null : ""}
                                                    </tbody>

                                                </>
                                            </table>
                                        </div>
                                    </div>
                                </div>)}
                    </>
                ) : null
                }

                {
                    this.state.isGridView === false ? (
                        <>
                            <div className="flex gap-2.5 mb-3">
                                <div className="start-date w-[50%] ">
                                    <label>Item Name</label>
                                    <input
                                        className="w-full"
                                        type="text"
                                        id="itemName"
                                        name="ItemName"
                                        disabled
                                        value={this.state.itemName}
                                        autoComplete="off"
                                    />

                                </div>
                                <button className="back-btn mt-auto" onClick={() => this.openGridView()}>Back</button>
                            </div>
                            <div class="item-listing">
                                <div class="itemList-table">
                                    <div className="table-container" style={{ height: "calc(100vh - 330px)" }}>
                                        <table class="itemList">
                                            <thead>
                                                <tr>
                                                    <td style={{ width: "5%" }}>Ref. No</td>
                                                    <td style={{ width: "7%" }}>Date</td>
                                                    <td style={{ width: "7%" }}>Party Name</td>
                                                    <td style={{ width: "5%" }}>Batch No</td>
                                                    <td style={{ width: "5%" }}>Receipt</td>
                                                    <td style={{ width: "10%" }}>Issue</td>
                                                    <td style={{ width: "10%" }}>From</td>
                                                </tr>
                                            </thead>
                                            {this.state.stockStatementByProductIdList &&
                                                this.state.stockStatementByProductIdList.length > 0 ? (
                                                this.state.stockStatementByProductIdList.map((details, key) => (
                                                    <tbody key={key}>
                                                        <tr>
                                                            <td>{details.refNo}</td>
                                                            <td>{details.refDate ? moment(details.refDate).format('DD MMM YYYY') : ''}</td>
                                                            <td>{details.partyName}</td>
                                                            <td>{details.batchNo}</td>
                                                            <td>{details.produceedQty ? details.produceedQty : ''}</td>
                                                            <td>{details.issuedQty ? details.issuedQty : ''}</td>
                                                            <td>{details.from ? details.from : ''}</td>
                                                        </tr>
                                                    </tbody>
                                                )
                                                )
                                            ) : (
                                                <tbody className="validation-body">
                                                    <tr>
                                                        <td
                                                            colSpan={6}
                                                            style={{ textAlign: "center", fontSize: "16px" }}
                                                        >
                                                            No Records Found
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )}
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="item-sections  min-w-[250px] max-w-[300px]  rounded-[10px] !px-3 !py-5  !bg-white mt-[20px]" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "#f5f5f5" }}>
                                <p className='!text-center !text-[17px] !font-semibold'>Summary</p>
                                <div className="search-grp flex gap-2">
                                    <div className="w-[40%] !flex !items-center !text-[14px] !font-medium !text-[#585858] !pt-[8px] ">
                                        Total Stock
                                    </div>
                                    <input
                                        className="inputFocus !w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                                        type="number"
                                        id="subTotal"
                                        name="subTotal"
                                        autocomplete="off"
                                        disabled
                                        value={this.state.totalProduceedQty}

                                    />
                                </div>
                                <div className="search-grp flex gap-2">
                                    <div className="w-[40%] !flex !items-center !text-[14px] !font-medium !text-[#585858] !pt-[8px] ">
                                        Total Issue
                                    </div>
                                    <input
                                        className="inputFocus !w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px]"
                                        type="number"
                                        id="crDrNote"
                                        name="crDrNote"
                                        autocomplete="off"
                                        disabled
                                        value={this.state.totalIssuedQty}
                                    />
                                </div>
                                <div className="search-grp flex gap-2">
                                    <div className="w-[40%] !flex !items-center !text-[14px] !font-medium !text-[#585858] !pt-[8px] ">
                                        Closing Balance
                                    </div>
                                    <input
                                        className="inputFocus !w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px]"
                                        type="number"
                                        id="crDrNote"
                                        name="crDrNote"
                                        autocomplete="off"
                                        disabled
                                        value={this.state.closingBalance}
                                    />
                                </div>



                            </div>
                        </>

                    ) : null
                }

                {/*----- Print layout -----*/}
                <div className='table-print mt-5 hidden' id="printableArea">
                    {/* Header */}
                    <div className="print-header">
                        <table className="hdr-table">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="co-name">{this.state.companyName}</div>
                                        <div className="rpt-sub">Stock Statement</div>
                                    </td>
                                    <td>
                                        <div className="hdr-meta">
                                            Start Date: <strong>{this.state.filterDetails.startDate}</strong><br />
                                            End Date: <strong>{this.state.filterDetails.endDate}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="rule-thick" />
                        <div className="rule-thin" />
                    </div>


                    <div className="print-content">

                        {/* <div className="info-row">
                                                      <div>
                                                        <span className="info-label">Item Name:</span>
                                                        <p className="info-value">Paracetamol</p>
                                                      </div>
                                                    </div> */}

                        {/* Table */}
                        <table className="data-tbl">
                            <colgroup>
                                <col style={{ width: "50%" }} />
                                <col style={{ width: "25%" }} />
                                <col style={{ width: "25%" }} />
                            </colgroup>

                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                        Item Name
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        MRP
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Stock
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.state.stockStatementReportList && this.state.stockStatementReportList.length > 0 ?
                                    this.state.stockStatementReportList.map((details, key) => (
                                        <tr key={key}>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.itemName}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.mrp}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.totalQty}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="3" style={{ textAlign: 'center' }}>
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    <div className="print-footer">
                        <div className="rule-foot">
                            <table className="foot-tbl">
                                <tbody>
                                    <tr>
                                        <td>* System generated report. No signature required.</td>
                                        <td style={{ textAlign: "right" }}>
                                            Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div >
        );
    }
}

export default StockStatementReport;